export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'saveStatus',
    align: 'center',
    width: 120,
    title: '导入状态',
    slots: {default: 'status'},
  },
  {
    field: 'errorMsg',
    align: 'left',
    headerAlign: 'center',
    title: '导入异常原因',
    width: 200,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'customerSortInfo',
    align: 'center',
    headerAlign: 'center',
    title: '客户序号',
    width: 200,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'custName',
    width: 100,
    align: 'center',
    title: '客户名称',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'custShortName',
    width: 100,
    align: 'center',
    title: '客户简称',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'customerTypeName',
    width: 100,
    align: 'center',
    title: '客户类型',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'custIndustry',
    width: 100,
    align: 'center',
    title: '客户行业',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'businessAddress',
    width: 100,
    align: 'center',
    title: '经营地址',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'custRemarks',
    width: 100,
    align: 'center',
    title: '备注信息',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'businessLicense',
    width: 100,
    align: 'center',
    title: '营业执照号',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'taxNumber',
    width: 100,
    align: 'center',
    title: '税号',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'establishmentDate',
    width: 100,
    align: 'center',
    title: '成立日期',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'registeredCapital',
    width: 100,
    align: 'center',
    title: '注册资金',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'legalRepresentative',
    width: 100,
    align: 'center',
    title: '法定代表人',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'phoneNo',
    width: 100,
    align: 'center',
    title: '固定电话',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'registeredAddress',
    width: 100,
    align: 'center',
    title: '注册地址',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'depositBank',
    width: 100,
    align: 'center',
    title: '开户银行',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'invoiceTitle',
    width: 100,
    align: 'center',
    title: '发票抬头',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'invoiceAddress',
    width: 100,
    align: 'center',
    title: '开票地址',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'bankAccount',
    width: 100,
    align: 'center',
    title: '银行账号',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'financialCode',
    width: 100,
    align: 'center',
    title: '财务代码',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'creditDays',
    width: 100,
    align: 'center',
    title: '信用天数',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'creditLimit',
    width: 100,
    align: 'center',
    title: '信用额度',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'isAutoSettlementName',
    width: 100,
    align: 'center',
    title: '是否自动生成账单',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'custSettlementDate',
    width: 100,
    align: 'center',
    title: '账单生成日',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'custSettlementConditionName',
    width: 100,
    align: 'center',
    title: '结算条件',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },

  {
    field: 'parentCustNo',
    width: 100,
    align: 'center',
    title: '结算客户',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'isNeedPodName',
    width: 100,
    align: 'center',
    title: '回单要求',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'podCycle',
    width: 100,
    align: 'center',
    title: '回单周期',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'electronicFence',
    width: 100,
    align: 'center',
    title: '默认电子围栏半径（米）',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'isMustCustPointsName',
    width: 100,
    align: 'center',
    title: '创建订单检查',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: '货物详情',
    align: 'center',
    children: [
      {
        field: 'goodsImport[0].customerSort',
        title: '关联客户序号',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'goodsImport[0].goodsName',
        width: 100,
        align: 'center',
        title: '货物名称',
        showHeaderOverflow: 'title',
        showOverflow: true,
      },
      {
        field: 'goodsImport[0].goodsType',
        width: 100,
        align: 'center',
        title: '货物类型',
        showHeaderOverflow: 'title',
        showOverflow: true,
      },
      {
        field: 'goodsImport[0].packageType',
        width: 100,
        align: 'center',
        title: '包装类型',
        showHeaderOverflow: 'title',
        showOverflow: true,
      },
      {
        field: 'goodsImport[0].packageLength',
        width: 100,
        align: 'center',
        title: '长(m)',
        showHeaderOverflow: 'title',
        showOverflow: true,
      },
      {
        field: 'goodsImport[0].packageWidth',
        width: 100,
        align: 'center',
        title: '宽(m)',
        showHeaderOverflow: 'title',
        showOverflow: true,
      },
      {
        field: 'goodsImport[0].packageHeight',
        width: 100,
        align: 'center',
        title: '高(m)',
        showHeaderOverflow: 'title',
        showOverflow: true,
      },
      {
        field: 'goodsImport[0].incomeWeight',
        width: 100,
        align: 'center',
        title: '收入重量（kg）',
        showHeaderOverflow: 'title',
        showOverflow: true,
      },
      {
        field: 'goodsImport[0].incomeVolume',
        width: 100,
        align: 'center',
        title: '收入体积（m³）',
        showHeaderOverflow: 'title',
        showOverflow: true,
      },
      {
        field: 'goodsImport[0].expenseWeight',
        width: 100,
        align: 'center',
        title: '支出重量（kg）',
        showHeaderOverflow: 'title',
        showOverflow: true,
      },
      {
        field: 'goodsImport[0].expenseVolume',
        width: 100,
        align: 'center',
        title: '支出体积（m³）',
        showHeaderOverflow: 'title',
        showOverflow: true,
      },
      {
        field: 'goodsImport[0].goodsRemarks',
        width: 100,
        align: 'center',
        title: '备注说明',
        showHeaderOverflow: 'title',
        showOverflow: true,
      },
    ],
  },
]
